var _defs, _path, _path2, _g, _g2, _path3, _path4, _path5, _path6, _path7, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _path8, _path9, _g15, _rect, _rect2, _rect3, _rect4, _g16, _g17;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgBrain = function SvgBrain(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 119.046,
    height: 93.815,
    viewBox: "0 0 119.046 93.815",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_1994",
    "data-name": "Ret\\xE2ngulo 1994",
    width: 5.781,
    height: 16.502,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_1995",
    "data-name": "Ret\\xE2ngulo 1995",
    width: 94.745,
    height: 55.054,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_1996",
    "data-name": "Ret\\xE2ngulo 1996",
    width: 6.892,
    height: 13.256,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-4"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_1997",
    "data-name": "Ret\\xE2ngulo 1997",
    width: 12.64,
    height: 23.255,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-5"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_1998",
    "data-name": "Ret\\xE2ngulo 1998",
    width: 79.938,
    height: 53.028,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-6"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_1999",
    "data-name": "Ret\\xE2ngulo 1999",
    width: 24.088,
    height: 10.008,
    fill: "#fd947a"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-7"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2000",
    "data-name": "Ret\\xE2ngulo 2000",
    width: 19.403,
    height: 12.248,
    fill: "#fd947a"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-8"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2001",
    "data-name": "Ret\\xE2ngulo 2001",
    width: 9.669,
    height: 6.39,
    fill: "#fd947a"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-9"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2002",
    "data-name": "Ret\\xE2ngulo 2002",
    width: 13.666,
    height: 14.439,
    fill: "#fd947a"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-10"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2003",
    "data-name": "Ret\\xE2ngulo 2003",
    width: 10.313,
    height: 15.548,
    fill: "#fd947a"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-11"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2004",
    "data-name": "Ret\\xE2ngulo 2004",
    width: 9.841,
    height: 11.859,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-12"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2005",
    "data-name": "Ret\\xE2ngulo 2005",
    width: 15.352,
    height: 15.982,
    fill: "#fd947a"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-13"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2008",
    "data-name": "Ret\\xE2ngulo 2008",
    width: 52.015,
    height: 21.453,
    fill: "#fd947a"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-14"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2009",
    "data-name": "Ret\\xE2ngulo 2009",
    width: 10.08,
    height: 13.781,
    fill: "#fd947a"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-15"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2013",
    "data-name": "Ret\\xE2ngulo 2013",
    width: 21.525,
    height: 13.205,
    fill: "#fd947a"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-16"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2007",
    "data-name": "Ret\\xE2ngulo 2007",
    width: 10.352,
    height: 13.263,
    fill: "#fd947a"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-17"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2016",
    "data-name": "Ret\\xE2ngulo 2016",
    width: 118.044,
    height: 93.608,
    transform: "translate(0 0)",
    fill: "#ff4a9d"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_6334",
    "data-name": "Grupo 6334",
    transform: "translate(0.994 0.215)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_4533",
    "data-name": "Caminho 4533",
    d: "M159.922,242.214c0-.082-.011-.163-.017-.245q-.02-.284-.051-.566c-.01-.093-.021-.186-.033-.278-.024-.186-.053-.37-.084-.553-.014-.082-.027-.165-.042-.246-.049-.26-.1-.519-.169-.773h0a12.461,12.461,0,0,0-7.364-8.355c-.035.457-.079.909-.141,1.352a19.008,19.008,0,0,1-1.086,4.243c-2.528,5.187-6.973,5.187-6.973,5.187,3.228-1.556,5.493-5.414,6.065-10.128a19.574,19.574,0,0,0,.14-2.105,17.5,17.5,0,0,0-2.623-9.735c-4.278-6.529-12.423-6.24-14.867-5.335-.015.4-.05.924-.12,1.531-.044.38-.1.792-.175,1.226-1.249,5.558-4.926,6.1-4.926,6.1,1.557-1.382,2.372-3.783,2.783-5.823a17.27,17.27,0,0,0,.382-3.582l-.056-.373c-.373-2.591-1.068-7.415-6.046-10.583-5.528-3.518-12.485-1.991-15.819-.106l-.009.005a20.3,20.3,0,0,0-3.069,2.278c-2.018,1.818-4.2,4.558-4.467,8.054a7.74,7.74,0,0,1,1.525-8.008,21.212,21.212,0,0,1,3.151-2.88c.506-.379.962-.687,1.336-.926a5.437,5.437,0,0,0-1.4-3.5c-1.376-1.587-4.457-3.577-11.315-4.045-9.353-.637-15.034,4.218-16.927,9.784a11.379,11.379,0,0,1,1.476-.2c3.988-.284,5.6,1.951,5.6,1.951a14.3,14.3,0,0,0-6.262.181,10.955,10.955,0,0,0-1.771.527l-.068.034c-4.986,2.458-7.918,6.177-8.715,11.053a17.437,17.437,0,0,0,1.108,9.358,9.293,9.293,0,0,0,1.16,1.525c1.965,2.146,6.479,5.449,14.022,2.354a7.676,7.676,0,0,1-5.839,3.319,13.329,13.329,0,0,1-3.359-.421,12.655,12.655,0,0,1-3.035-1.223,13.6,13.6,0,0,1-2.925-2.228,13.417,13.417,0,0,1-.922-1.017c-1.956,3.41-3.8,9.4-2.257,15.149,1.22,4.557,4.9,7.628,7.128,9.126,0-.015,0-.029-.005-.043a8.333,8.333,0,0,1-.008-1.541,5.114,5.114,0,0,1,2.07-3.958,28.129,28.129,0,0,0-.006,5.292c.068.7.16,1.383.284,2.049.681,3.648,2.534,8.465,7.5,10.7a16.724,16.724,0,0,0,10.058,1.2,11.2,11.2,0,0,1-.566-1.193,15.544,15.544,0,0,1-.667-8.558,10.122,10.122,0,0,1-4.1-1.521c-3.086-3-1.6-5.78-1.6-5.78.223,1.113,1.317,4.639,6.2,5.293A7.757,7.757,0,0,1,97.267,250c-2.811,2.5-5.474,9.906-3.091,15.268a8.985,8.985,0,0,0,1.026,1.758c6.256,7.6,15.554,7.207,19.849,4.794a4.529,4.529,0,0,1-.589-1.145,8.26,8.26,0,0,1-.257-3.765,7.659,7.659,0,0,0,1.584,2.8,8.617,8.617,0,0,0,1.462,1.382c8.237,5,15.641,3.4,19.328-.409l.395-.407h.005a7.259,7.259,0,0,0,.862-1.138c1.316-2.138,1.761-5.171,1.25-8.765,0,0,3.009,4.066,1.24,8.418-.1.236-.208.465-.321.689a9.918,9.918,0,0,1-.722,1.213c6.48.9,14.016-.462,17.494-6.875a14.679,14.679,0,0,0,1.832-10.226c-.137.18-.276.356-.42.527-.223.263-.454.51-.69.748a11.72,11.72,0,0,1-1.81,1.507c-2.732,1.7-6.815-.312-6.815-.312a8.884,8.884,0,0,0,7.74-3.277c.1-.116.189-.239.283-.36a12.7,12.7,0,0,0,1.132-1.719l.026-.05q.18-.332.343-.678c.025-.053.049-.107.073-.16q.139-.3.267-.614.033-.08.065-.161.133-.338.252-.684c.011-.032.023-.064.033-.1a16.546,16.546,0,0,0,.626-2.518c.007-.044.014-.088.021-.132q.056-.355.1-.712c.006-.056.013-.112.019-.168q.038-.365.06-.73c0-.04.006-.08.008-.119.015-.287.023-.573.022-.859,0-.009,0-.019,0-.028,0-.262-.01-.522-.024-.782m-40.676,22.794a14.266,14.266,0,0,1-4.135-.625c-5.4-1.632-9.841-6.231-10.566-10.935a16.561,16.561,0,0,1,2.806-12.391,8.027,8.027,0,0,1,8.9-2.775,10.356,10.356,0,0,0-7.037,4.164,14.232,14.232,0,0,0-2.372,10.649c.586,3.8,4.431,7.7,8.944,9.066,2.634.8,7.74,1.379,12.344-3.663,0,0,0,5.6-8.881,6.509m21.661-32.5a11.733,11.733,0,0,1-2.912,4.185,9.46,9.46,0,0,1-6.191,2.343,9,9,0,0,1-2.6-.387,16.086,16.086,0,0,1-.713,6.861,8.7,8.7,0,0,0,5.563,6.126,7.365,7.365,0,0,0,6.738-.943s-1.964,4.632-7.378,2.9a10.284,10.284,0,0,1-6.131-5.5,12.383,12.383,0,0,1-1.3,1.761c-4.648,3.831-8.763,1.734-8.763,1.734a9.611,9.611,0,0,0,7.025-3.272c1.492-1.686,3.161-4.709,2.64-9.538-.8-7.43-6.537-15.039-17.232-14.18a17.682,17.682,0,0,0-15.515,11.945c.413.123.833.269,1.257.442a9.484,9.484,0,0,1,5.624,7.964c-2.7-4.243-6.339-6.544-10.515-6.653a13.933,13.933,0,0,0-11.025,5.285s-.085-4.283,5.811-6.792a15.316,15.316,0,0,1,5.275-.813c.41.011.844.043,1.292.1a17.549,17.549,0,0,1,4.006-7.115,3.479,3.479,0,0,0-1.69-4.219l-.058-.034.011-.018a16.894,16.894,0,0,1-5.235-5.05c-4.16-3.1-9.644-1.139-10.318-.394,0,0,0-2.677,3.55-3.284a11.956,11.956,0,0,1,5.236.55c-.021-.063-.045-.124-.066-.187a12.971,12.971,0,0,1,1.157-10.5,7.5,7.5,0,0,1,6.135-3.649,15.809,15.809,0,0,0-4.13,4.816,10.647,10.647,0,0,0-.954,8.621,13.408,13.408,0,0,0,5.794,7.1h0l.044.026c.056.032.106.068.16.1a10.094,10.094,0,0,0,6.172,1.647,20.529,20.529,0,0,1,7.8-2.2c.318-.026.634-.043.948-.055a15.035,15.035,0,0,1,1.118-7.716,5.99,5.99,0,0,1,6.118-3.622c-4.627,2.034-5.734,8.016-5.149,11.357a17.36,17.36,0,0,1,10.743,4.323,18.174,18.174,0,0,1,5.506,9.4,6.934,6.934,0,0,0,7.724-1.035,10.832,10.832,0,0,0,2.916-10.3s3.516,2.218,1.516,7.869",
    transform: "translate(-61.803 -183.986)",
    fill: "#ffa9d3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_4534",
    "data-name": "Caminho 4534",
    d: "M159.922,242.214c0-.082-.011-.163-.017-.245q-.02-.284-.051-.566c-.01-.093-.021-.186-.033-.278-.024-.186-.053-.37-.084-.553-.014-.082-.027-.165-.042-.246-.049-.26-.1-.519-.169-.773h0a12.461,12.461,0,0,0-7.364-8.355c-.035.457-.079.909-.141,1.352a19.008,19.008,0,0,1-1.086,4.243c-2.528,5.187-6.973,5.187-6.973,5.187,3.228-1.556,5.493-5.414,6.065-10.128a19.574,19.574,0,0,0,.14-2.105,17.5,17.5,0,0,0-2.623-9.735c-4.278-6.529-12.423-6.24-14.867-5.335-.015.4-.05.924-.12,1.531-.044.38-.1.792-.175,1.226-1.249,5.558-4.926,6.1-4.926,6.1,1.557-1.382,2.372-3.783,2.783-5.823a17.27,17.27,0,0,0,.382-3.582l-.056-.373c-.373-2.591-1.068-7.415-6.046-10.583-5.528-3.518-12.485-1.991-15.819-.106l-.009.005a20.3,20.3,0,0,0-3.069,2.278c-2.018,1.818-4.2,4.558-4.467,8.054a7.74,7.74,0,0,1,1.525-8.008,21.212,21.212,0,0,1,3.151-2.88c.506-.379.962-.687,1.336-.926a5.437,5.437,0,0,0-1.4-3.5c-1.376-1.587-4.457-3.577-11.315-4.045-9.353-.637-15.034,4.218-16.927,9.784a11.379,11.379,0,0,1,1.476-.2c3.988-.284,5.6,1.951,5.6,1.951a14.3,14.3,0,0,0-6.262.181,10.955,10.955,0,0,0-1.771.527l-.068.034c-4.986,2.458-7.918,6.177-8.715,11.053a17.437,17.437,0,0,0,1.108,9.358,9.293,9.293,0,0,0,1.16,1.525c1.965,2.146,6.479,5.449,14.022,2.354a7.676,7.676,0,0,1-5.839,3.319,13.329,13.329,0,0,1-3.359-.421,12.655,12.655,0,0,1-3.035-1.223,13.6,13.6,0,0,1-2.925-2.228,13.417,13.417,0,0,1-.922-1.017c-1.956,3.41-3.8,9.4-2.257,15.149,1.22,4.557,4.9,7.628,7.128,9.126,0-.015,0-.029-.005-.043a8.333,8.333,0,0,1-.008-1.541,5.114,5.114,0,0,1,2.07-3.958,28.129,28.129,0,0,0-.006,5.292c.068.7.16,1.383.284,2.049.681,3.648,2.534,8.465,7.5,10.7a16.724,16.724,0,0,0,10.058,1.2,11.2,11.2,0,0,1-.566-1.193,15.544,15.544,0,0,1-.667-8.558,10.122,10.122,0,0,1-4.1-1.521c-3.086-3-1.6-5.78-1.6-5.78.223,1.113,1.317,4.639,6.2,5.293A7.757,7.757,0,0,1,97.267,250c-2.811,2.5-5.474,9.906-3.091,15.268a8.985,8.985,0,0,0,1.026,1.758c6.256,7.6,15.554,7.207,19.849,4.794a4.529,4.529,0,0,1-.589-1.145,8.26,8.26,0,0,1-.257-3.765,7.659,7.659,0,0,0,1.584,2.8,8.617,8.617,0,0,0,1.462,1.382c8.237,5,15.641,3.4,19.328-.409l.395-.407h.005a7.259,7.259,0,0,0,.862-1.138c1.316-2.138,1.761-5.171,1.25-8.765,0,0,3.009,4.066,1.24,8.418-.1.236-.208.465-.321.689a9.918,9.918,0,0,1-.722,1.213c6.48.9,14.016-.462,17.494-6.875a14.679,14.679,0,0,0,1.832-10.226c-.137.18-.276.356-.42.527-.223.263-.454.51-.69.748a11.72,11.72,0,0,1-1.81,1.507c-2.732,1.7-6.815-.312-6.815-.312a8.884,8.884,0,0,0,7.74-3.277c.1-.116.189-.239.283-.36a12.7,12.7,0,0,0,1.132-1.719l.026-.05q.18-.332.343-.678c.025-.053.049-.107.073-.16q.139-.3.267-.614.033-.08.065-.161.133-.338.252-.684c.011-.032.023-.064.033-.1a16.546,16.546,0,0,0,.626-2.518c.007-.044.014-.088.021-.132q.056-.355.1-.712c.006-.056.013-.112.019-.168q.038-.365.06-.73c0-.04.006-.08.008-.119.015-.287.023-.573.022-.859,0-.009,0-.019,0-.028,0-.262-.01-.522-.024-.782m-31.434,3.3",
    transform: "translate(-61.803 -183.986)",
    fill: "#ffe0d1"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_5917",
    "data-name": "Grupo 5917",
    transform: "translate(2.313 43.646)",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_5916",
    "data-name": "Grupo 5916"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_5915",
    "data-name": "Grupo 5915",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_4536",
    "data-name": "Caminho 4536",
    d: "M45.473,862.881l.862-.484s-.733-7.792,4.3-13.323a29.4,29.4,0,0,0-2.578-2.695s-4.9,10.249-2.578,16.5",
    transform: "translate(-44.85 -846.38)",
    fill: "#fff"
  }))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_5920",
    "data-name": "Grupo 5920",
    transform: "translate(4.191 8.607)",
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_5919",
    "data-name": "Grupo 5919"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_5918",
    "data-name": "Grupo 5918",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_4537",
    "data-name": "Caminho 4537",
    d: "M81.457,197.064l1.679.378s-.051-7.34,4.161-11.723a19.028,19.028,0,0,1,12.6-5.833c-1.767-.785-4.214-1.949-4.214-1.949a13.083,13.083,0,0,1,6.229-5.884c4.727-2.321,12.548-1.031,15.3.516s2.793,3.457,3.008,5.5c-.859,1.031-4.69,5.616-3.763,9.64,1.7-3.538,4.279-7.287,9.693-9.022s11.6-.79,15.384,3.937,3.132,12.552,1.222,15.214a30.607,30.607,0,0,0,4.926-6.1,14.208,14.208,0,0,1,10.1,1.368c5.243,2.836,5.844,8.784,6.016,11.526s-.982,8.618-4.53,11.653c3.241-1.778,5.91-2.756,7.756-7.768,2.7.919,9.251,5.066,7.568,13.435,1.153-1.859,4.935-11.962-7.442-18.212-.43-6.508-2.578-17.767-19.252-16.907-2.406-6.618-9.282-17.1-23.205-12.032-3.79-4.635-20.971-17.07-34.12,3.884-5.586,3.593-10.224,10.715-9.106,18.376",
    transform: "translate(-81.29 -166.902)",
    fill: "#fff"
  }))))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_4538",
    "data-name": "Caminho 4538",
    d: "M296.117,1403.464s2.487,12.043,15.682,10.663c.046-1.38-1.388-4.311-1.388-4.311s-10.512,1.212-14.294-6.352",
    transform: "translate(-280.848 -1331.09)",
    fill: "#fd947a",
    opacity: 0.2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_4539",
    "data-name": "Caminho 4539",
    d: "M636.972,1476.8c-1.031,4.868,3.944,11.6,12.028,13.149s9.423-1.546,9.423-1.546l-2.091-4.317a12.175,12.175,0,0,1-8.634,1.481c-5.4-.859-9.75-5.075-10.726-8.767",
    transform: "translate(-603.998 -1400.643)",
    fill: "#fd947a",
    opacity: 0.2
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_4540",
    "data-name": "Caminho 4540",
    d: "M84.793,1067.631c-1.038,3.447,1.121,9.913,6.407,13.236l2.1-4.5a12.422,12.422,0,0,1-8.5-8.732",
    transform: "translate(-80.18 -1012.576)",
    fill: "#fd947a",
    opacity: 0.2
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_4541",
    "data-name": "Caminho 4541",
    d: "M705.794,824.241c.068-.055.135-.11.2-.164-.083-.02-.167-.044-.251-.066.016.076.033.152.046.23",
    transform: "translate(-669.355 -781.52)",
    fill: "#fe52a7"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_4542",
    "data-name": "Caminho 4542",
    d: "M803.62,104.164a20.276,20.276,0,0,1,3.884,9.419,19.842,19.842,0,0,1,3.191,1.762c1.944-2.7,3.645-8.507,2.278-14.086C811.685,96,808,91.938,802.534,89.736a9.571,9.571,0,0,1-4.221,5.13,16.95,16.95,0,0,0,2.352-5.809l-.021-.007.207-.9c.067-.3,1.58-7.348-3.806-12.149-5.485-4.888-12.4-5.717-16.6-4.082,1.2,4.274-1.747,7.816-1.747,7.816a10.335,10.335,0,0,0-.415-7.833,15.233,15.233,0,0,0-10.76-6.759,15.072,15.072,0,0,0-11.258,3.25,7.954,7.954,0,0,0-2.292,4.463,5.8,5.8,0,0,1,.138-4.9,15.561,15.561,0,0,0-17.369,1.119,16.682,16.682,0,0,1,10.012,6.865c6.059-1.814,11.935-1.193,16.627,1.773a17.339,17.339,0,0,1,1.785,1.3c1.75-2.226,1.914-6.636,1.25-7.771,0,0,2.759,1.091,2.085,5.08a10.16,10.16,0,0,1-1.83,4.091,16.111,16.111,0,0,1,4.166,8.094,19.659,19.659,0,0,1,10.02,1.434,3.858,3.858,0,0,0,3.584-2.021c.97-1.522,2.917-5.465.056-9.211a5.169,5.169,0,0,1,3.68,5.387c.065-.034.128-.071.193-.1a4.12,4.12,0,0,1,5.511,1.5,6.12,6.12,0,0,0-6.521,1.867,13.225,13.225,0,0,1-.963,1.8c-.02.031-.041.059-.062.09a6.987,6.987,0,0,0-.417,4.352,20.48,20.48,0,0,1,4.954,12.8c5.732,2.765,8.888,6.991,9.384,12.567a22.886,22.886,0,0,1-1.888,10.6,19.562,19.562,0,0,1,.283,7.671c4.485-.4,11.038-2.732,13.069-8.1,1.8-4.761,1.224-9.206-1.505-11.608a20.16,20.16,0,0,0-2.513-1.574c.008.264.013.526.013.784,0,5.8-3.651,7.763-3.651,7.763.029-.075,2.943-7.733.007-14.863-2.677-6.5-7.1-8.455-10.345-8.119,0,0,3.17-2.7,7.8.421.246.211.49.436.73.674a12.945,12.945,0,0,0,4.094-3.257,5.668,5.668,0,0,1-2.734,4.8",
    transform: "translate(-698.752 -61.688)",
    fill: "#fee0d1"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_5923",
    "data-name": "Grupo 5923",
    transform: "translate(108.178 53.098)",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_5922",
    "data-name": "Grupo 5922"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_5921",
    "data-name": "Grupo 5921",
    clipPath: "url(#clip-path-3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_4543",
    "data-name": "Caminho 4543",
    d: "M2097.784,1029.661l.675,3.659s6.033,1.511,4.494,9.6c1.557-2.661,2.589-7.044.719-9.364s-5.887-3.892-5.887-3.892",
    transform: "translate(-2097.783 -1029.661)",
    fill: "#fff"
  }))))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_5926",
    "data-name": "Grupo 5926",
    transform: "translate(94.977 39.563)",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_5925",
    "data-name": "Grupo 5925"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_5924",
    "data-name": "Grupo 5924",
    clipPath: "url(#clip-path-4)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_4544",
    "data-name": "Caminho 4544",
    d: "M1847.675,768.212s-3.971-1.646-5.9-.737c5.294,2.456,11.7,7.563,10.338,22.982,2.876-3.565,3.123-12.447.372-16.83s-4.814-5.415-4.814-5.415",
    transform: "translate(-1841.779 -767.201)",
    fill: "#fff"
  }))))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_5929",
    "data-name": "Grupo 5929",
    transform: "translate(36.326 1.898)",
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_5928",
    "data-name": "Grupo 5928"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_5927",
    "data-name": "Grupo 5927",
    clipPath: "url(#clip-path-5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_4545",
    "data-name": "Caminho 4545",
    d: "M704.45,42.836l5,.624s6.63-4.016,13.419.032l.481,2.575a11.239,11.239,0,0,1,7.017-5.294c5.092-1.354,11.775-.012,15.019,4.131a11.47,11.47,0,0,1,2.69,8.043s2.08-4.38,2.03-5.508a16.928,16.928,0,0,1,14.081,2.68c4.813,3.438,6.494,11.285,3.5,17.96,2.34-2.748,3.1-2.91,3.1-2.91s6.2.764,9.9,8.757-1.289,15.384-1.289,15.384l1.2.516s6.188-7.735,2.75-16.416a21.413,21.413,0,0,0-11.517-11.6s2.149-11.6-7.219-15.126S748.54,43.76,748.54,43.76,744.521,36.8,737.893,36.8s-13.074,3.438-13.074,3.438-13.236-6.661-20.369,2.6",
    transform: "translate(-704.45 -36.798)",
    fill: "#fff"
  }))))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_5932",
    "data-name": "Grupo 5932",
    transform: "translate(52.396 80.098)",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_5931",
    "data-name": "Grupo 5931"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_5930",
    "data-name": "Grupo 5930",
    clipPath: "url(#clip-path-6)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_4546",
    "data-name": "Caminho 4546",
    d: "M1040.169,1553.255s-.869,10.316-12.954,10c-11.753-.306-11.128-7.177-11.128-7.177s2.488,3.655,8.87,4.235,12.892-2.739,15.212-7.058",
    transform: "translate(-1016.081 -1553.255)",
    fill: "#fd947a"
  }))))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_5935",
    "data-name": "Grupo 5935",
    transform: "translate(75.582 75.553)",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_5934",
    "data-name": "Grupo 5934"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_5933",
    "data-name": "Grupo 5933",
    clipPath: "url(#clip-path-7)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_4547",
    "data-name": "Caminho 4547",
    d: "M1485.083,1465.13s-1.418,9.282-10.238,11.1c-9.459,1.95-9.165.824-9.165.824s2.965-5.66,3.219-7.744c1.293,3.212,11.091,6.326,16.183-4.181",
    transform: "translate(-1465.68 -1465.13)",
    fill: "#fd947a"
  }))))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_5938",
    "data-name": "Grupo 5938",
    transform: "translate(24.016 65.982)",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_5937",
    "data-name": "Grupo 5937"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_5936",
    "data-name": "Grupo 5936",
    clipPath: "url(#clip-path-8)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_4548",
    "data-name": "Caminho 4548",
    d: "M467.569,1283.888s-1.931-1.028-1.868-4.349c1.61,2.308,5.477,4.672,9.667.8a23.9,23.9,0,0,0-2.73,5.587Z",
    transform: "translate(-465.7 -1279.539)",
    fill: "#fd947a"
  }))))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_5941",
    "data-name": "Grupo 5941",
    transform: "translate(98.852 62.275)",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_5940",
    "data-name": "Grupo 5940"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_5939",
    "data-name": "Grupo 5939",
    clipPath: "url(#clip-path-9)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_4549",
    "data-name": "Caminho 4549",
    d: "M1930.615,1207.63s.32,10.5-9.445,12.726l-4.221,1.713v-6.188s10.958,1.934,13.665-8.251",
    transform: "translate(-1916.95 -1207.63)",
    fill: "#fd947a"
  }))))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_5944",
    "data-name": "Grupo 5944",
    transform: "translate(103.277 37.674)",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_5943",
    "data-name": "Grupo 5943"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_5942",
    "data-name": "Grupo 5942",
    clipPath: "url(#clip-path-10)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_4550",
    "data-name": "Caminho 4550",
    d: "M2005.191,733.393l1.918-2.813s-1.059,6.586,1.691,9.126,4.3-1.757,4.3-1.757a20.383,20.383,0,0,1-2.528,8.055,9,9,0,0,1-2.886,0l-4.9-10.977Z",
    transform: "translate(-2002.784 -730.58)",
    fill: "#fd947a"
  }))))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_5947",
    "data-name": "Grupo 5947",
    transform: "translate(87.076 60.254)",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_5946",
    "data-name": "Grupo 5946"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_5945",
    "data-name": "Grupo 5945",
    clipPath: "url(#clip-path-11)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_4551",
    "data-name": "Caminho 4551",
    d: "M1698.451,1168.464s.171,12.641-9.841,11.821c4.512-2.023,8.552-4.172,9.841-11.821",
    transform: "translate(-1688.61 -1168.464)",
    fill: "#ce6aaa"
  }))))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_5950",
    "data-name": "Grupo 5950",
    transform: "translate(6.918 33.139)",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_5949",
    "data-name": "Grupo 5949"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_5948",
    "data-name": "Grupo 5948",
    clipPath: "url(#clip-path-12)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_4552",
    "data-name": "Caminho 4552",
    d: "M134.674,642.631c-1.031,4.082-1.031,10.356,4.383,14.4s10.438-.911,10.438-.911-14.563.568-14.821-13.484",
    transform: "translate(-134.143 -642.631)",
    fill: "#fd947a"
  }))))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_5959",
    "data-name": "Grupo 5959",
    transform: "translate(43.117 9.666)",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_5958",
    "data-name": "Grupo 5958"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_5957",
    "data-name": "Grupo 5957",
    clipPath: "url(#clip-path-13)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_4555",
    "data-name": "Caminho 4555",
    d: "M836.117,188.7l.217-1.256s6.462,5.184,11.889,1.5c.27,1.56,7.1,5.431,12.665,2.292.668.986,1.967.126,1.967.126a12.281,12.281,0,0,0,1.881,7.478c2.32,3.352,12.376,8.091,14.826,3.49,1.5-1.685,1.938-4.617-.815-7.534,2.834.177,7.253,1.11,9.384,6.789-1.6-1.525-7.065-.6-8.1,2.412a11.751,11.751,0,0,1-3.438,4.9l-12.806-2.578s-2.059-12.2-14.91-13.064c-3.139.6-8.468,1.461-8.468,1.461Z",
    transform: "translate(-836.117 -187.443)",
    fill: "#fd947a"
  }))))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_5962",
    "data-name": "Grupo 5962",
    transform: "translate(88.064 26.135)",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_5961",
    "data-name": "Grupo 5961"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_5960",
    "data-name": "Grupo 5960",
    clipPath: "url(#clip-path-14)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_4556",
    "data-name": "Caminho 4556",
    d: "M1709.4,506.8c-1.2,1.891-2.32,4.555-1.117,9.626s6.394,4.076,6.394,4.076l3.169-1.079a7.075,7.075,0,0,1-5.524-2.294c-2.321-2.594-3.094-5.774-2.922-10.329",
    transform: "translate(-1707.762 -506.797)",
    fill: "#fd947a"
  }))))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_4557",
    "data-name": "Caminho 4557",
    d: "M117.478,38.771A19.751,19.751,0,0,0,105.64,25.187a16.126,16.126,0,0,0-5.115-13.38C94.906,6.8,87.091,4.875,81.174,6.846a18.194,18.194,0,0,0-12-6.724A18.62,18.62,0,0,0,56.645,3.139c-9.767-5.244-19.636-.7-22.613,3.6l-.045.064c-.365-.035-.735-.066-1.113-.092-11.688-.8-18.733,6.052-20.653,13.126-6.711,3.691-8.906,9.062-9.55,13a21.225,21.225,0,0,0,.884,10.088C1.388,46.52-1.289,53.657.7,61.066c1.745,6.514,7.3,10.388,9.636,11.767,1.34,5.715,4.573,9.97,9.185,12.05a19.969,19.969,0,0,0,12.283,1.4,20.313,20.313,0,0,0,12.826,6.331A17.931,17.931,0,0,0,54.986,90.7a22.471,22.471,0,0,0,10.683,2.9A16.223,16.223,0,0,0,76.245,89.9a26.756,26.756,0,0,0,11.074-.415,16.527,16.527,0,0,0,10.608-8.064,22.513,22.513,0,0,0,1.155-2.469c5.539-.176,14.251-2.99,17.024-10.321,1.979-5.229,1.578-10.285-.973-13.73a22.6,22.6,0,0,0,2.345-16.134M98.122,59.894c0,.04-.006.08-.008.119q-.022.365-.06.73c-.006.056-.013.112-.019.168q-.041.357-.1.712c-.007.044-.014.088-.021.132a16.546,16.546,0,0,1-.626,2.518c-.011.032-.022.064-.033.1q-.118.346-.252.684-.032.081-.065.161-.127.311-.267.614c-.024.053-.048.107-.073.16q-.164.345-.343.678l-.026.05A12.7,12.7,0,0,1,95.1,68.436c-.094.12-.185.244-.283.36a8.884,8.884,0,0,1-7.74,3.277s4.083,2.016,6.815.312a11.713,11.713,0,0,0,1.81-1.507c.236-.238.467-.485.69-.748.144-.171.284-.347.42-.527A14.679,14.679,0,0,1,94.98,79.827C91.5,86.241,83.966,87.6,77.486,86.7a9.921,9.921,0,0,0,.722-1.213c.113-.224.222-.453.321-.689,1.77-4.352-1.24-8.418-1.24-8.418.511,3.594.065,6.628-1.25,8.765a7.252,7.252,0,0,1-.862,1.139h-.005l-.395.407C71.09,90.5,63.685,92.1,55.449,87.1a8.616,8.616,0,0,1-1.463-1.382,7.66,7.66,0,0,1-1.584-2.8,8.26,8.26,0,0,0,.257,3.765,4.528,4.528,0,0,0,.589,1.145c-4.3,2.413-13.593,2.81-19.849-4.794a8.986,8.986,0,0,1-1.026-1.758c-2.383-5.362.28-12.77,3.091-15.268a7.757,7.757,0,0,0-5.245,5.266c-4.886-.654-5.981-4.18-6.2-5.293,0,0-1.484,2.781,1.6,5.78a10.122,10.122,0,0,0,4.1,1.521,15.544,15.544,0,0,0,.667,8.558,11.2,11.2,0,0,0,.566,1.193,16.724,16.724,0,0,1-10.058-1.2c-4.964-2.239-6.817-7.056-7.5-10.7-.124-.666-.217-1.351-.284-2.049a28.13,28.13,0,0,1,.006-5.292,5.114,5.114,0,0,0-2.07,3.958,8.333,8.333,0,0,0,.008,1.541c0,.015,0,.029.005.043-2.227-1.5-5.907-4.57-7.128-9.126-1.54-5.749.3-11.74,2.257-15.149a13.418,13.418,0,0,0,.922,1.017A13.6,13.6,0,0,0,10.037,48.3a12.655,12.655,0,0,0,3.035,1.223,13.327,13.327,0,0,0,3.359.421,7.676,7.676,0,0,0,5.839-3.32c-7.543,3.095-12.057-.208-14.022-2.354a9.292,9.292,0,0,1-1.16-1.525A17.437,17.437,0,0,1,5.98,33.382c.8-4.877,3.729-8.6,8.715-11.053l.068-.034a10.956,10.956,0,0,1,1.771-.527,14.3,14.3,0,0,1,6.262-.181s-1.612-2.235-5.6-1.951a11.386,11.386,0,0,0-1.476.2c1.893-5.566,7.574-10.421,16.927-9.784,6.859.468,9.939,2.458,11.315,4.045a5.437,5.437,0,0,1,1.4,3.5c-.374.239-.83.547-1.336.926a21.213,21.213,0,0,0-3.151,2.88,7.74,7.74,0,0,0-1.525,8.008c.269-3.5,2.449-6.236,4.467-8.054a20.3,20.3,0,0,1,3.069-2.278l.009-.005c3.334-1.886,10.291-3.412,15.819.106,4.978,3.168,5.672,7.992,6.046,10.583l.056.373a17.268,17.268,0,0,1-.382,3.582c-.411,2.041-1.226,4.441-2.783,5.823,0,0,3.677-.539,4.926-6.1.074-.434.131-.846.175-1.226.07-.607.106-1.13.12-1.531,2.444-.906,10.59-1.194,14.867,5.335a17.5,17.5,0,0,1,2.623,9.735,19.567,19.567,0,0,1-.14,2.105c-.571,4.714-2.837,8.572-6.065,10.128,0,0,4.444,0,6.973-5.187a19.008,19.008,0,0,0,1.086-4.243c.062-.443.106-.9.141-1.352a12.461,12.461,0,0,1,7.364,8.355h0c.065.254.12.513.169.773.016.081.028.164.042.246.031.183.06.367.084.553.012.092.023.185.033.278q.031.282.051.566c.006.082.013.163.017.245.014.26.023.52.024.782,0,.009,0,.019,0,.028,0,.286-.008.572-.023.859M107.6,37.67a12.944,12.944,0,0,1-4.094,3.257c-.24-.238-.484-.463-.73-.674-4.634-3.122-7.8-.421-7.8-.421,3.248-.337,7.668,1.617,10.345,8.119,2.936,7.13.022,14.788-.007,14.863,0,0,3.652-1.962,3.651-7.763,0-.258,0-.52-.013-.784a20.169,20.169,0,0,1,2.513,1.574c2.729,2.4,3.306,6.847,1.505,11.608-2.031,5.368-8.584,7.7-13.069,8.1a19.563,19.563,0,0,0-.283-7.671,22.886,22.886,0,0,0,1.888-10.6c-.5-5.576-3.652-9.8-9.384-12.567a20.479,20.479,0,0,0-4.954-12.8,6.987,6.987,0,0,1,.417-4.352c.02-.031.042-.059.062-.09a13.218,13.218,0,0,0,.963-1.8A6.12,6.12,0,0,1,95.131,23.8a4.12,4.12,0,0,0-5.511-1.5c-.065.032-.128.07-.193.1a5.169,5.169,0,0,0-3.68-5.387c2.86,3.746.914,7.69-.056,9.211a3.858,3.858,0,0,1-3.584,2.021,19.66,19.66,0,0,0-10.02-1.434,16.112,16.112,0,0,0-4.166-8.094,10.16,10.16,0,0,0,1.83-4.091c.675-3.99-2.085-5.08-2.085-5.08.664,1.134.5,5.545-1.25,7.771a17.329,17.329,0,0,0-1.785-1.3C59.939,13.053,54.062,12.432,48,14.246A16.682,16.682,0,0,0,37.992,7.381,15.561,15.561,0,0,1,55.361,6.261a5.8,5.8,0,0,0-.138,4.9A7.954,7.954,0,0,1,57.514,6.7a15.073,15.073,0,0,1,11.258-3.25,15.233,15.233,0,0,1,10.76,6.759,10.335,10.335,0,0,1,.415,7.833S82.891,14.5,81.7,10.227c4.2-1.635,11.115-.806,16.6,4.082,5.387,4.8,3.873,11.853,3.806,12.149l-.207.9.02.007a16.949,16.949,0,0,1-2.352,5.809,9.571,9.571,0,0,0,4.221-5.13c5.461,2.2,9.151,6.26,10.44,11.523,1.366,5.579-.335,11.391-2.278,14.086a19.843,19.843,0,0,0-3.191-1.762,19.733,19.733,0,0,0-1.287-4.825,19.934,19.934,0,0,0-2.6-4.595,5.668,5.668,0,0,0,2.734-4.8",
    transform: "translate(0 0.004)",
    fill: "#fd947a"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_4561",
    "data-name": "Caminho 4561",
    d: "M20.363,5.991A15.641,15.641,0,0,0,13.519.748,12.786,12.786,0,0,0,7.075.173,16.778,16.778,0,0,0,.385,2.861.965.965,0,0,0,1.545,4.4,14.246,14.246,0,0,1,7.453,2a10.76,10.76,0,0,1,5.473.557,14.009,14.009,0,0,1,5.922,4.625.962.962,0,0,0,.751.366h.006a.964.964,0,0,0,.757-1.561",
    transform: "translate(42.039 71.193) rotate(-7)",
    fill: "#d3502f"
  })), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_5982",
    "data-name": "Grupo 5982",
    transform: "matrix(0.695, -0.719, 0.719, 0.695, 26.131, 43.063)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_5976",
    "data-name": "Grupo 5976",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_5984",
    "data-name": "Grupo 5984"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_5974",
    "data-name": "Grupo 5974"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_5973",
    "data-name": "Grupo 5973"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_5972",
    "data-name": "Grupo 5972",
    clipPath: "url(#clip-path-15)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_4564",
    "data-name": "Caminho 4564",
    d: "M0,0C.13,6.714,3.11,8.824,6.684,11.434S18.939,14.164,21.525,9.09c-2.007,1.475-7.7,2.345-13.923-.357A14.425,14.425,0,0,1,0,0",
    fill: "#fd947a"
  })))))))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2049",
    "data-name": "Ret\\xE2ngulo 2049",
    width: 11.801,
    height: 10.49,
    rx: 5.245,
    transform: "translate(31.766 50.545)",
    fill: "#bf7a68"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2052",
    "data-name": "Ret\\xE2ngulo 2052",
    width: 11.801,
    height: 10.49,
    rx: 5.245,
    transform: "translate(60.613 50.545)",
    fill: "#bf7a68"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2051",
    "data-name": "Ret\\xE2ngulo 2051",
    width: 11.801,
    height: 10.49,
    rx: 5.245,
    transform: "translate(31.766 47.922)",
    fill: "#fee0d1"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2053",
    "data-name": "Ret\\xE2ngulo 2053",
    width: 11.801,
    height: 10.49,
    rx: 5.245,
    transform: "translate(60.613 47.922)",
    fill: "#fee0d1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_5956",
    "data-name": "Grupo 5956",
    transform: "matrix(0.848, -0.53, 0.53, 0.848, 57.883, 41.314)",
    opacity: 0.3,
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_5955",
    "data-name": "Grupo 5955"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_5954",
    "data-name": "Grupo 5954",
    clipPath: "url(#clip-path-16)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_4554",
    "data-name": "Caminho 4554",
    d: "M1.289,0s-2.9,7.068,0,10.667,9.064,2.408,9.064,2.408S.94,11.018,1.289,0",
    transform: "translate(0 0)",
    fill: "#fd947a"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_6332",
    "data-name": "Grupo 6332",
    transform: "translate(-0.994 -0.215)",
    opacity: 0.4,
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }, _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_6329",
    "data-name": "Grupo 6329",
    clipPath: "url(#clip-path-17)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8558",
    "data-name": "Caminho 8558",
    d: "M117.476,38.777a19.749,19.749,0,0,0-11.838-13.584,16.126,16.126,0,0,0-5.115-13.38C94.9,6.806,87.089,4.881,81.172,6.852a18.2,18.2,0,0,0-12-6.724A18.618,18.618,0,0,0,56.643,3.145c-9.767-5.244-19.636-.7-22.613,3.6l-.045.064c-.365-.035-.735-.066-1.113-.092-11.688-.8-18.733,6.052-20.653,13.126-6.711,3.691-8.906,9.062-9.55,13a21.223,21.223,0,0,0,.884,10.088C1.386,46.526-1.291,53.663.7,61.072,2.443,67.586,8,71.46,10.334,72.839c1.34,5.715,4.573,9.97,9.185,12.05a19.973,19.973,0,0,0,12.283,1.4A20.314,20.314,0,0,0,44.628,92.62a17.933,17.933,0,0,0,10.356-1.914,22.478,22.478,0,0,0,10.683,2.9,16.223,16.223,0,0,0,10.576-3.7,26.75,26.75,0,0,0,11.074-.415,16.525,16.525,0,0,0,10.608-8.064,22.436,22.436,0,0,0,1.155-2.469c5.539-.176,14.251-2.99,17.024-10.321,1.979-5.229,1.578-10.285-.973-13.73a22.6,22.6,0,0,0,2.345-16.134",
    fill: "#ff4a9d"
  }))))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgBrain, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/brain.b16267bc.svg";
export { ForwardRef as ReactComponent };